import Swiper from 'swiper/bundle';
import GET_ARTICLES from '../class/getArticles';
import { worksBlock } from "../class/works-block";

const [d] = [document];

class Blocks {
    constructor() {
      this.init();
      new worksBlock;
    }

    init() {
        this.headline();
        this.news('.block-news__list[data-plugin="getArticles"]');
    }

    mainvisual() {
        //メインスライダー
        new Swiper('.mainvisual-slider[data-plugin="mainSlider"]', {
            direction: 'vertical',
            loop: true,
            effect: 'fade',
            speed: 1500,
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                waitForTransition: false,
            },
            pagination: {
                el: '.mainvisual__slider-pager',
                clickable: true,
            },
        });
    }

    headline() {
        const getArticle = new GET_ARTICLES(
            '.mainvisual-headline__article[data-plugin="getArticles"]'
        );
        getArticle.makeItem = (item, content) => `
      <a href="${item.href}" class="mainvisual-headline__link">
        <span class="date">${item.date}</span>
        <h3 class="subject ${
            item.is_new ? 'is-new' : ''
        }">${item.title}</h3>
      </a>
      `;
        getArticle.render();
    }

    news(selector)
  {
    const news_block = new GET_ARTICLES(selector);
    const getCategories = this.fetchCategories('news');
    const categoryContainer = d.querySelectorAll('.block-news [data-plugin="getCategories"]');
    news_block.makeItem = (item,content) => `
    <li class="block-${content}-item">
      <a href="/${content}/?mode=detail&amp;article=${item.id}" class="block-${content}-item__link">
        <div class="block-${content}-item__body">
          <div class="date-cate">
            <span class="date">${item.date}</span><span class="cate">${item.category.name}</span>
          </div>
          <h4 class="title ${item.is_new? 'is-new':''}">${item.title}</h4>
        </div>
      </a>
    </li>
    `;
    // news_block.makeItem = (item) => console.log(item);
    news_block.render();

    getCategories.then((cats) => {
      cats = [...cats];
      const makeHTML = (cat) => `<div class="block-news__categories-item is-${cat.id}"><a href="${cat.href}">${cat.name}</a></div>`;
      categoryContainer.forEach((obj) => {
        obj.innerHTML = '';
        cats.forEach((cat) =>
          obj.insertAdjacentHTML('beforeend', makeHTML(cat))
        );
      });
    });
  }
    fetchCategories(content) {
        return fetch(`/assets/api/getCategories/?content=${content}`)
            .then((r) => r.json())
            .catch((e) => {
                throw new Error(e);
            });
    }

    fetchArticles(opt) {
        return fetch(`/assets/api/getArticles/?${new URLSearchParams(opt)}`)
            .then((r) => r.json())
            .catch((e) => {
                throw new Error(e);
            });
    }
}

const domReady = (TPL) => {
    let blocks = new Blocks();
    window.addEventListener('load', () => {
        blocks.mainvisual();
        blocks.newsslider();
    });
};

const jqInit = () => false;

export default function HOME() {
    // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
    d.addEventListener('rwd002.beforeDomready', (e) => domReady(e.detail));

    $(() => jqInit());
}
